/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import TwitterApi from 'scripts/social/twitter';
import template from './twitter-embed.stache';

const POST_URL_REG_EXP = /https?:\/\/twitter\.com\/(?:\#!\/)?(\w+)\/status(es)?\/(\d+)/ig;

Component.extend({
    tag: 'twitter-embed',
    template: template,
    events: {
        inserted: function () {
            let socialID = this.parsePostUrl();
            if (socialID){
                TwitterApi.create(this.element.find('.c-twitter-embed'), {socialID: socialID}, {width:'auto'})
            }
        },

        parsePostUrl: function () {
            if (this.viewModel.attr('postUrl')) {
                let regexp = new RegExp(POST_URL_REG_EXP);
                let hrefArr = regexp.exec(this.viewModel.attr('postUrl'));
                return hrefArr && hrefArr[3] ? hrefArr[3] : null;
            } else{
                return null;
            }
        }
    }
});
